import React from 'react';
import { useDispatch } from 'react-redux';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { indexDocumentTemplateRequest } from '../../requests/documentTemplates';
import { InputSelect } from '../../components';

const ContractTerminationModal = ({ errors, touched, setFieldValue, isSubmitting }) => {
  const dispatch = useDispatch();

  const fetchDocumentTemplates = (inputValue, callback) => {
    indexDocumentTemplateRequest({
      dispatch,
      params: {
        query: inputValue,
        template_type: 'termination_contract_notice_letter',
        sort_column: 'name',
        display_length: 150
      },
      successCallback: response => callback(response.data.data)
    });
  };

  return (
    <Form>
      <Modal.Body>
        <h4 className="mt-0 mb-4">Seleccione la plantilla que será enviada al correo del empleado</h4>
        <Row>
          <Col>
            <Field name="templatePdf[templateId]">
              {({ field }) => (
                <InputSelect
                  {...field}
                  abbr
                  label="Plantilla"
                  placeholder="Seleccionar Plantilla"
                  value={undefined}
                  request={fetchDocumentTemplates}
                  onChange={data => setFieldValue(field.name, data ? data.value : '')}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button type="submit" disabled={isSubmitting}>
          Guardar
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = () => {
  return {
    templatePdf: {
      documentType: 'termination_contract_notice_letter',
      templateId: ''
    }
  };
};

const validationSchema = Yup.object().shape({
  templatePdf: Yup.object().shape({
    templateId: Yup.string().required('Debes seleccionar una plantilla')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(ContractTerminationModal);
